import { useEffect } from 'react';

// import JSON
import aboutPageJson from '../../configs/about.json';

export default function About() {
    const monthAbrev = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const sortedData = Object.keys(aboutPageJson["ENGAGEMENT"])
        .sort((a, b) => Number(b) - Number(a)) // sort years DESC
        .flatMap((year) => {
            let sortedMonth = Object.keys(aboutPageJson["ENGAGEMENT"][year])
                // Sort Month with Desc
                .sort((a, b) => Number(b) - Number(a))
                .flatMap((month) => {
                    // Return value month with data appended to it
                    return ({month, data: aboutPageJson["ENGAGEMENT"][year][month]})
                });
            // Return value year with whatever that is appended to month
            return ({ year, data: sortedMonth })
    });

    function getMonthName(monthNumber) {
        return monthAbrev[monthNumber - 1];
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    return (
        <div className="AboutPage">
            <div className="AboutPage-Timeline-Container-Outer">
                <div className="AboutPage-Timeline-Title">
                    Years of Engagement
                </div>
                <div className="AboutPage-Timeline-Content-Container">
                    {
                        sortedData.map((YearData, index) => {
                            return (
                                <div key={"EventData" + index} className="AboutPage-Timeline-Container-Inner">
                                    <div className="AboutPage-Timeline-Year">
                                        {YearData["year"]}
                                    </div>
                                    <div className="AboutPage-Timeline-Period-Container">
                                        {
                                            index === 0 ? "" : <div className="fading-line"/>
                                        }
                                    {
                                        YearData["data"].map((MonthData, index) => {
                                            return (
                                                <div key={"MonthData" + index} className="AboutPage-Timeline-Item-Container">
                                                    <div className="AboutPage-Timeline-Month">
                                                        {getMonthName(MonthData["month"])}
                                                    </div>
                                                    {
                                                        MonthData["data"].map((EventData, index) => {
                                                            return (
                                                                <div key={"data" + index} className="AboutPage-Timeline-Event-Container-Outer">
                                                                    {
                                                                        EventData["image"] === undefined ? "" : EventData["image"] === "" ? "" :
                                                                        <div className="AboutPage-Timeline-Event-Image-Container">
                                                                            <img alt="some display" className="AboutPage-Timeline-Event-Image" src={EventData["image"]}/>
                                                                        </div>
                                                                    }
                                                                    <div className="AboutPage-Timeline-Event-Container-Inner">
                                                                        <div className="AboutPage-Timeline-Event-Name">
                                                                            {EventData["event"]}
                                                                        </div>
                                                                        <div className="AboutPage-Timeline-Event-Summary">
                                                                            {EventData["description"]}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                    
                                                </div>
                                            )
                                        })
                                    }
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        </div>
    );
}
